import { UnitSystem, ftToM } from '../../../../utils/unitConversion';

/** "TOL @ 5000 MD ft"  →  "TOL @ 1524.00 M MD" */
export const fmtTol = (tol: number | null | undefined, us: UnitSystem): string => {
  if (tol == null) return '';
  if (us === 'imperial') return `TOL @ ${tol} MD ft`;
  return `TOL @ ${ftToM(tol).toFixed(2)} M MD`;
};

/** "@ 5000 MD ft"  →  "@ 1524.00 M MD" */
export const fmtDepth = (depth: number | null | undefined, us: UnitSystem): string => {
  if (depth == null) return '';
  if (us === 'imperial') return `@ ${depth} MD ft`;
  return `@ ${ftToM(depth).toFixed(2)} M MD`;
};

/** "@ 4850.25 MD ft"  →  "@ 1478.34 M MD"  (pre-rounded float) */
export const fmtBottom = (bottom: number | null | undefined, us: UnitSystem): string => {
  if (bottom == null) return '';
  if (us === 'imperial') return `@ ${bottom.toFixed(2)} MD ft`;
  return `@ ${ftToM(bottom).toFixed(2)} M MD`;
};
